<template>
	<div class="con">
		<div class="head">
			<img class="user-img" :src="userInfo.headimgurl" />
			<div class="head-right">
				<div>{{userInfo.nickname}}</div>
			</div>
			<div class="canvas">
				<canvas id="Theback"></canvas>
			</div>
		</div>
		<div class="licon-sp">
			<div v-for="item in navList" @click="toNavBtn(item.to)">
				{{item.text}}
			</div>
		</div>
		<div class="list-con">
			<div class="list-li">
				<div class="list-text" v-for="item in list" @click="navTo( item.id, item.to)">
					<img :src="item.img" />
					<div>{{item.text}}</div>
				</div>
			</div>
		</div>

		<div class="wxfooter">
			<div class="wf" @click="toHome">
				<img src="../assets/home.png" />
				<div>首页</div>
			</div>
			<div class="wf">
				<img src="../assets/userActive.png" />
				<div class="wx-active">个人中心</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'user',
		data() {
			return {
				msg: '个人中心',
				navList: [{
						id: 0,
						text: '我的卡号',
						to: '/patient'
					},
					{
						id: 1,
						text: '我关注的医生',
						to: '/collection'
					},
				],
				userInfo: '',
				cardUserInfo: '',
				list: [{
						id: 0,
						text: '挂号记录',
						img: require('../assets/registered.png'),
						to: '/regQuery'
					},
					{
						id: 1,
						text: '就诊报告',
						img: require('../assets/auscultation.png'),
						to: '/prescriptionList'
					},

					{
						id: 2,
						text: '门诊缴费记录',
						img: require('../assets/knowledge.png'),
						to: '/paymentRecordsList'
					},
					// {
					// 	id: 3,
					// 	text: '医生互动',
					// 	img: require('../assets/homecon.png'),
					// 	to: '/communicationList'
					// },
					// {
					// 	id: 4,
					// 	text: '危急值提醒',
					// 	img: require('../assets/dynamic.png'),
					// 	to: '/remind'
					// },
					{
						id: 5,
						text: '医生消息',
						img: require('../assets/communication.png'),
						to: '/emLogin'
					},
					{
						id: 6,
						text: '建议反馈',
						img: require('../assets/vote.png'),
						to: '/collectionScore'
					},
					{
						id: 7,
						text: '我的消息',
						img: require('../assets/website.png'),
						to: '/chatMessage'
					},
				]
			}
		},
		methods: {
			toNavBtn(e) {
				this.$router.push({
					path: e
				})
			},
			navTo(id, e) {
				if (this.cardUserInfo != null) {
					switch (id) {
						case 5:
							this.$router.push({
								path: e,
								query: {
									type: 1
								}
							}, )
							break;
						case 6:
							this.$router.push({
								path: e,
								query: {
									type: 0
								}
							}, )
							break;
							case 7://病人看谁给我发的消息
								this.$router.push({
									path: e,
									query: {
										type: 1
									}
								}, )
								break;
						default:
							this.$router.push({
									path: e,
								})
					}

					} else {
						this.$dialog.alert({
							title: "提示",
							message: "您还没有登录卡号",
							confirmButtonText: "确定", //改变确认按钮上显示的文字
							//				         cancelButtonText: "取消" //改变取消按钮上显示的文字
						}).then(() => {
							console.log("点击了确认按钮")
						}).catch(() => {
							console.log("点击了取消按钮")
						})
					}
				},
				toHome() {
						this.$router.replace({
							path: '/'
						})
					},

					wavesurRecord() {
						//获取画布
						var beisizer = document.getElementById("Theback");
						var ContenofBeisizer = beisizer.getContext("2d"); //设置波浪海域（海浪宽度，高度）
						var beisizerwidth = beisizer.width;
						var beisizerheight = beisizer.height;
						var beisizerlinewidth = 2; //曲线
						var sinX = 0;
						var sinY = beisizerheight / 1.2; //轴长
						var axisLenght = beisizerwidth; //弧度宽度
						var waveWidth = 0.014; //海浪高度
						var waveHeight = beisizerheight / 15.0;
						var speed = 0.1; //数值越大速率越快
						var xofspeed = 0; //波浪横向的偏移量
						var rand = beisizerheight; //波浪高度

						ContenofBeisizer.lineWidth = beisizerlinewidth;

						// 创建静态的曲线
						var drawSin = function(xofspeed) {
							ContenofBeisizer.save(); //存放贝塞尔曲线的各个点
							var points = [];
							ContenofBeisizer.beginPath(); //创建贝塞尔点
							for (var x = sinX; x < sinX + axisLenght; x += 80 / axisLenght) {
								//							var y = -Math.sin((sinX + x) * waveWidth);  //测试请解开注释，注释下一行
								var y = -Math.sin((sinX + x) * waveWidth + xofspeed);
								//							points.push([x, sinY + y * waveHeight]); //测试请解开注释，注释下一行
								points.push([x, rand + y * waveHeight]);
								ContenofBeisizer.lineTo(x, sinY + y * waveHeight); //测试请解开注释，注释下一行
								//							 ContenofBeisizer.lineTo(x, rand + y * waveHeight);
							}

							ContenofBeisizer.lineTo(axisLenght, beisizerheight);
							ContenofBeisizer.lineTo(sinX, beisizerheight);
							ContenofBeisizer.lineTo(points[0][0], points[0][1]);
							ContenofBeisizer.stroke();
							ContenofBeisizer.restore(); //贝塞尔曲线样式设置
							ContenofBeisizer.strokeStyle = "#fff";
							ContenofBeisizer.fillStyle = "#fff";
							ContenofBeisizer.fill();
						};

						var rendY = function() {
							ContenofBeisizer.clearRect(0, 0, beisizerwidth, beisizerheight); //控制海浪高度
							var tmp = 0.1;
							rand -= tmp;
							var b = beisizerheight - rand;
							//控制循环涨潮
							if (parseInt(b) == beisizerheight) {
								rand = beisizerheight;
							}
							drawSin(xofspeed);
							xofspeed += speed;
							requestAnimationFrame(rendY);
						};

						// 动态
						drawSin();
						rendY();

					}
			},
			mounted() {
				if (localStorage.getItem('userInfo') != undefined) {
					this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
				}
				this.wavesurRecord();
			},
			created(){
				// history.pushState(null, null, document.URL)
				// window.addEventListener('popstate', function() {
				//   history.pushState(null, null, document.URL)
				// })
			}
			
		}
</script>

<style scoped>
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.head {
		position: relative;
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 20px 0 50px;
		background: linear-gradient(to right, #27BEC4 0%, #8DD7DA 50%, #BDE8E9 100%);
	}

	.canvas {
		position: absolute;
		bottom: -5px;
		z-index: 10;
		width: 100%;
		height: 150px;
	}

	#Theback {
		width: 100%;
		height: 100%;
	}

	.user-img {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		overflow: hidden;
	}

	.head-right {
		font-size: 15px;
	}

	.list-con {
		position: relative;
		flex: 1;
	}

	.licon-sp {
		display: flex;
		justify-content: space-around;
		align-items: center;
		margin: 10px auto;
		padding: 25px 10px;
		background: #fff;
		width: 80%;
		box-shadow: 2px 2px 2px #ccc;
		border-radius: 10px;
		font-size: 15px;
	}

	.list-li {
		display: flex;
		flex-wrap: wrap;
	}

	.list-text {
		margin: 20px 0;
		font-size: 15px;
		text-align: center;
		width: 33%;
	}

	.list-text img {
		margin-bottom: 5px;
		width: 40px;
		height: 40px;
	}

	.wxfooter {
		padding: 5px 0;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background: #FFFFFF;
	}

	.wf {
		text-align: center;
		font-size: 14px;
	}

	.wf img {
		width: 30px;
		height: 30px;
	}

	.wx-active {
		color: #27BEC4;
	}
</style>
